import { render, staticRenderFns } from "./LeaveRecord.vue?vue&type=template&id=71d0870f"
import script from "./LeaveRecord.vue?vue&type=script&lang=js"
export * from "./LeaveRecord.vue?vue&type=script&lang=js"
import style0 from "./LeaveRecord.vue?vue&type=style&index=0&id=71d0870f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports